module.exports = __webpack_public_path__ + "media/images/plans/dinner/occation-3-ea278c4ec54d4255f8c006065d2e17f2.jpg";